// /policy-diff — the public plain-English renter vs CFI comparison (Design
// round 3 "Policy Diff" screen), linked from both checkout screens. Static
// content. Design's DC for this page has not synced to the repo, so this
// copy is CC-drafted plain language pending Design's verbatim pass. The
// specimen links point at Global's own SAMPLE PDFs, published from
// web-ctr/public/specimens/ (round 3.1).
import Footer from '@/components/Footer.jsx';
import Wordmark from '@/components/Wordmark.jsx';
import { BNO_SPECIMEN_URL, C123_SPECIMEN_URL } from '@/lib/specimens.js';

const ROWS = [
  ['Who it covers', 'You, renting aircraft you do not own.', 'You, renting and instructing in aircraft you do not own.'],
  ['Flying for money', 'Not covered. No flights for hire, no charging for your flying.', 'Instructing is covered under the CFI extension. Everything else for hire is still not covered.'],
  ['Aircraft it applies to', 'The types you selected, 7 seats or fewer, 500 horsepower or less.', 'Same types, seats and horsepower rules.'],
  ['Who must be flying', 'You as pilot in command, current and rated.', 'You as PIC or instructing; your student flying the airplane while you instruct is the point of the extension.'],
  ['Damage to the rented aircraft', 'Covered up to the limit you chose.', 'Covered up to the limit you chose, including while instructing.'],
  ['Ownership rule', 'No coverage in aircraft you (or your household) own 25% or more of.', 'Same rule.'],
  ['Long rentals', 'Leases of 30 days or longer must be reported.', 'Same rule.'],
  ['If you cancel', 'At least 50% of the premium is earned and not refundable.', 'Same rule.'],
];

export default function PolicyDiff() {
  return (
    <div className="mx-auto min-h-screen max-w-[860px] bg-white px-5 py-10 shadow-shell lg:px-10">
      <a href="/" className="text-xl text-primary"><Wordmark /></a>
      <h1 className="mb-2 mt-6 text-[28px] font-bold tracking-[-0.02em]">Renter policy vs CFI extension, in plain English</h1>
      <p className="mb-7 max-w-[620px] text-[15px] leading-[1.6] text-ink-dim">
        The same non-owned policy underwrites both. The CFI extension changes one thing that matters a lot:
        whether you are covered while instructing. The policy documents prevail over this summary, always.
      </p>
      <div className="overflow-x-auto">
        <div className="min-w-[640px] overflow-hidden rounded-panel border border-line">
          <div className="grid grid-cols-[1fr_1.2fr_1.2fr] bg-fill text-xs font-bold uppercase tracking-[0.05em] text-ink-dim">
            <div className="p-[13px_18px]" />
            <div className="p-[13px_18px]">Renter policy</div>
            <div className="p-[13px_18px] text-primary">With the CFI extension</div>
          </div>
          {ROWS.map(([k, renter, cfi]) => (
            <div key={k} className="grid grid-cols-[1fr_1.2fr_1.2fr] border-t border-line bg-white text-[13.5px] leading-[1.55]">
              <div className="p-[13px_18px] font-semibold">{k}</div>
              <div className="p-[13px_18px] text-ink-dim">{renter}</div>
              <div className="p-[13px_18px] text-ink-soft">{cfi}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="mt-6 flex flex-wrap gap-4 text-[13px] font-semibold">
        <a className="text-accent" href={BNO_SPECIMEN_URL} target="_blank" rel="noreferrer">Read the policy specimen (PDF)</a>
        <a className="text-accent" href={C123_SPECIMEN_URL} target="_blank" rel="noreferrer">Read the CFI endorsement specimen (PDF)</a>
      </div>
      <p className="mt-6 max-w-[640px] text-[11.5px] leading-[1.6] text-ink-faint">
        This summary is educational and not part of any policy. Coverage by Global Aerospace, arranged by NDEMNIFLY
        Aviation Insurance, CA License #6018700. Your policy&apos;s own terms, limits and exclusions control.
      </p>
      <Footer />
    </div>
  );
}
